import moment from "moment";
import React, { useState, useEffect } from "react";

export const useDeviceType = () => {
  const [width, setWidth] = useState(window.innerWidth) ;
  const [height, setHeight] = useState(window.innerHeight)
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;
  const mobileCap = isMobile ? 56 : 70
  return {
    isMobile,
    headerLessHeight: height - mobileCap,
    width
  };
};


export const printMomentDate = (date) => {
  return moment(date).format("DD-MMM-YYYY")
}